/**
 * Leichte Startseiten-Animationen ohne Transformation kompletter Shopify-Sektionen.
 * Dadurch bleiben Sticky-Elemente und das Scrollen stabil; nur kleine Inhalte werden einmalig animiert.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var STAGGER_STEP_MS = 45;
  var MAX_STAGGER_MS = 135;
  var TARGET_SELECTOR = [
    '.cc-home-categories__header',
    '.cc-home-category',
    '.cc-home-rail__header',
    '.cc-home-rail__card',
    '.cc-story__trust > div',
    '.cc-story__section > .cc-story__kicker',
    '.cc-story__section > h2',
    '.cc-story__steps article',
    '.cc-story__brands',
    '.cc-story__cta'
  ].join(',');

  function init() {
    var targets = document.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var batchIndex = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var delay = Math.min(batchIndex * STAGGER_STEP_MS, MAX_STAGGER_MS);
          entry.target.style.setProperty('--cc-reveal-delay', delay + 'ms');
          entry.target.classList.add('cc-reveal-visible');
          observer.unobserve(entry.target);
          batchIndex += 1;
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -3% 0px' }
    );

    targets.forEach(function (target, index) {
      target.style.setProperty('--cc-reveal-delay', Math.min((index % 4) * STAGGER_STEP_MS, MAX_STAGGER_MS) + 'ms');
      target.classList.add('cc-reveal-init');

      var rect = target.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.08 && rect.bottom > 0) {
        requestAnimationFrame(function () { target.classList.add('cc-reveal-visible'); });
      } else {
        observer.observe(target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
